import { Route, AppId, createPageRoute } from '@lumapps/router';

export const mobileGeneralSettingsRoute: Route = createPageRoute({
    slug: 'mobile/general-settings',
    appId: AppId.backOffice,
});
